export const ApiErrorCodes = {
    serviceNotSupported: 'ServiceNotSupported',
};

export const Defaults = {
    pageSize: 20
};